export default "__VITE_ASSET__DJR8eqwX__"